var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-item" },
    [
      _c("Spinner", { attrs: { "is-loading": _vm.isLoading } }),
      !_vm.errorMessageForUser && !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "interaction-card" },
            [
              _c(
                "div",
                { staticClass: "interactions-history" },
                [
                  _c(
                    "h3",
                    [
                      _vm._v(" " + _vm._s(_vm.$t("titleInteractions")) + " "),
                      _c("b-button", {
                        staticClass: "is-pulled-right",
                        class: _vm.showNewInteractionForm
                          ? "is-button-primary"
                          : "is-primary",
                        attrs: {
                          id: "show-add-interaction-form",
                          disabled: !_vm.checkUserFeature(
                            "element.collectings.button.add-interaction"
                          ),
                          "icon-right": _vm.showNewInteractionForm
                            ? "times"
                            : "comment-medical",
                        },
                        on: {
                          click: function ($event) {
                            _vm.showNewInteractionForm =
                              !_vm.showNewInteractionForm
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  !_vm.showNewInteractionForm
                    ? [
                        _vm.useDateFilters
                          ? _c(
                              "div",
                              { staticClass: "date-filter med-size-text" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("labeldateFilterFrom")) +
                                          ":"
                                      ),
                                    ]),
                                    _c("b-datepicker", {
                                      attrs: {
                                        id: "datepicker-from",
                                        size: "is-small",
                                        rounded: "",
                                        label: "Desde",
                                        locale: "es-ES",
                                      },
                                      model: {
                                        value: _vm.currentDateConstraints.from,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentDateConstraints,
                                            "from",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentDateConstraints.from",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("labeldateFilterTo")) +
                                          ":"
                                      ),
                                    ]),
                                    _c("b-datepicker", {
                                      attrs: {
                                        id: "datepicker-to",
                                        size: "is-small",
                                        rounded: "",
                                        locale: "es-ES",
                                      },
                                      model: {
                                        value: _vm.currentDateConstraints.to,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.currentDateConstraints,
                                            "to",
                                            $$v
                                          )
                                        },
                                        expression: "currentDateConstraints.to",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        !_vm.interactions || _vm.interactions.length === 0
                          ? _c("Message", {
                              attrs: {
                                "as-card": false,
                                message: _vm.$t("no-interactions-to-show"),
                                icon: "Information_flow.svg",
                              },
                            })
                          : _c(
                              "div",
                              { staticClass: "backoffice-interactions" },
                              _vm._l(
                                _vm.interactions,
                                function (interaction, interactionIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: interaction._id,
                                      staticClass:
                                        "interaction card-item shadowless",
                                      class:
                                        _vm.extendedClientDefault ===
                                        interactionIndex
                                          ? "details-showed"
                                          : "",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "interaction-header",
                                          on: {
                                            click: function ($event) {
                                              _vm.extendedClientDefault ===
                                              interactionIndex
                                                ? (_vm.extendedClientDefault =
                                                    undefined)
                                                : (_vm.extendedClientDefault =
                                                    interactionIndex)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "interaction-header-contact",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas content-title big-size-text",
                                                class:
                                                  _vm.contactMethodsMap[
                                                    `${interaction.contactMethod}`
                                                  ] &&
                                                  _vm.contactMethodsMap[
                                                    `${interaction.contactMethod}`
                                                  ].icon
                                                    ? _vm.contactMethodsMap[
                                                        `${interaction.contactMethod}`
                                                      ].icon
                                                    : "fa-comment-slash",
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "header-date med-size-text",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .formatDate(
                                                            interaction.createdAt
                                                          )
                                                          .split(" ")[0]
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .formatDate(
                                                            interaction.createdAt
                                                          )
                                                          .split(" ")[1]
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "interaction-header-user",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "content-title med-size-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      interaction.createdBy.name
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "small-size-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      interaction.createdBy
                                                        .email
                                                    )
                                                  ),
                                                ]
                                              ),
                                              interaction.isImportant
                                                ? _c("span", [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-star has-text-warning",
                                                    }),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "interaction-header-details",
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "fa content-title big-size-text",
                                                class:
                                                  _vm.extendedClientDefault ===
                                                  interactionIndex
                                                    ? "fa-minus-circle"
                                                    : "fa-plus-circle",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "interaction-details",
                                          class:
                                            _vm.extendedClientDefault ===
                                            interactionIndex
                                              ? "show"
                                              : "hide",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "interaction-details-comment",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(interaction.comment)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "interaction-details-complements",
                                            },
                                            _vm._l(
                                              _vm.fields,
                                              function (field) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: field.name,
                                                    staticClass: "control",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tag is-info is-light",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(field.title)
                                                        ),
                                                      ]
                                                    ),
                                                    !field.useDictionary &&
                                                    field.type === "select"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm.getTextFromBoolean(
                                                                    interaction[
                                                                      field.name
                                                                    ]
                                                                  )
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.type === "datepicker"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                interaction[
                                                                  field.name
                                                                ] ||
                                                                  _vm.$t("null")
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.type === "text"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                interaction[
                                                                  field.name
                                                                ] ||
                                                                  _vm.$t("null")
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.title === "Status" &&
                                                    field.useGlobalTrad
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `prospectStatus.${
                                                                    interaction[
                                                                      field.name
                                                                    ] || "null"
                                                                  }`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.title ===
                                                      "Sub-Status" &&
                                                    field.useGlobalTrad
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `prospectSubStatus.${
                                                                    interaction[
                                                                      field.name
                                                                    ] || "null"
                                                                  }`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.name ===
                                                    "availabilityInitialHour"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                interaction[
                                                                  field.name
                                                                ] ||
                                                                  _vm.$t("null")
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.name ===
                                                    "availabilityEndHour"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                interaction[
                                                                  field.name
                                                                ] ||
                                                                  _vm.$t("null")
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    field.useDictionary &&
                                                    !field.useGlobalTrad
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tag is-light",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  interaction[
                                                                    field.name
                                                                  ] || "null"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.showNewInteractionForm
                ? [
                    (_vm.managingType === "SINGLE" &&
                      _vm.currentBackofficeRelatedUser._id ===
                        _vm.currentUserId) ||
                    _vm.managingType === "MULTIPLE"
                      ? _c("AddInteractionForm", {
                          attrs: {
                            "contact-methods": _vm.contactMethods,
                            fields: _vm.fields,
                          },
                          on: {
                            "update:fields": function ($event) {
                              _vm.fields = $event
                            },
                            "create-new-interaction": function ($event) {
                              return _vm.$emit("create-new-interaction", $event)
                            },
                          },
                        })
                      : _c("div", [
                          _vm.currentBackofficeRelatedUser
                            ? _c("h4", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("managedBy")) +
                                    " " +
                                    _vm._s(
                                      _vm.currentBackofficeRelatedUser.name
                                    ) +
                                    " "
                                ),
                                _c("small", { staticClass: "has-text-grey" }, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.currentBackofficeRelatedUser.email
                                      ) +
                                      ")"
                                  ),
                                ]),
                              ])
                            : _c("h4", [
                                _c("small", { staticClass: "has-text-grey" }, [
                                  _vm._v(
                                    "(" + _vm._s(_vm.notBeingManaged) + ")"
                                  ),
                                ]),
                              ]),
                        ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm.errorMessageForUser
        ? _c("Message", {
            attrs: {
              message: _vm.errorMessageForUser,
              icon: "data_maintenance.svg",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }